import React from 'react';
import { useNavigate, useLocation } from 'react-router-dom';
import logo from '../../assets/images/footer-logo.png';
import emailIcon from '../../assets/images/email.png';
import instagramIcon from '../../assets/images/Instagram.png';
import linkedinIcon from '../../assets/images/LinkedIn.png';
import youtubeIcon from '../../assets/images/Youtube.png';
import XIcon from '../../assets/images/X.png';

function Footer() {
  const navigate = useNavigate();
  const location = useLocation();

  const scrollToSection = (section) => {
    // If already on home page → scroll immediately
    if (location.pathname === '/') {
      if (section === 'home') {
        window.scrollTo({ top: 0, behavior: 'smooth' });
      } else if (section === 'about') {
        const aboutEl = document.querySelector('[data-section="about"]');
        aboutEl?.scrollIntoView({ behavior: 'smooth' });
      } else if (section === 'contact') {
        const contactEl = document.querySelector('[data-section="contact"]');
        contactEl?.scrollIntoView({ behavior: 'smooth' });
      } else if (section === 'howtouse') {
        const videoEl = document.getElementById('demo-video');
        videoEl?.scrollIntoView({ behavior: 'smooth' });
      }
    } else {
      // From another page → go to home + remember where to scroll
      navigate('/', { state: { scrollTo: section } });
    }
  };

  return (
    <footer className="bg-white w-full px-4 py-8">
      <div className="max-w-[1200px] mx-auto flex flex-col lg:flex-row lg:justify-between gap-y-8">

        {/* Logo + Description */}
        <div className="flex flex-col items-center text-center lg:items-start lg:text-left order-1">
          <img src={logo} alt="Logo" className="w-[144px] h-[80px]" />
          <p className="text-[30px] leading-tight mt-4" style={{ fontFamily: 'Dongle, sans-serif', color: '#77808B' }}>
            The Mail Whale is a smart <br /> Parcel Locker System
          </p>
        </div>

        {/* Navigation Links */}
        <div className="flex flex-col items-center lg:flex-row lg:justify-center lg:gap-32 order-2">
          <div className="flex w-full justify-center gap-10 md:gap-20 lg:gap-32">
            {/* Column 1 */}
            <div className="flex flex-col items-center md:items-start">
              <button
                onClick={() => scrollToSection('home')}
                className="text-[36.31px] hover:text-blue-600"
                style={{ fontFamily: 'Dongle, sans-serif', color: '#3A75B4' }}
              >
                Home
              </button>
              <button
                onClick={() => scrollToSection('about')}
                className="text-[36.31px] mt-4 hover:text-blue-600"
                style={{ fontFamily: 'Dongle, sans-serif', color: '#3A75B4' }}
              >
                About Us
              </button>
            </div>

            {/* Column 2 */}
            <div className="flex flex-col items-center md:items-start">
              <button
                onClick={() => scrollToSection('contact')}
                className="text-[36.31px] hover:text-blue-600"
                style={{ fontFamily: 'Dongle, sans-serif', color: '#3A75B4' }}
              >
                Contact Us
              </button>
              <button
                onClick={() => scrollToSection('howtouse')}
                className="text-[36.31px] mt-4 hover:text-blue-600"
                style={{ fontFamily: 'Dongle, sans-serif', color: '#3A75B4' }}
              >
                How To Use?
              </button>
            </div>
          </div>
        </div>

        {/* Email & Social */}
        <div className="flex flex-col items-center lg:items-start lg:mt-[24.74px] order-3">
          <a
            href="https://mail.google.com/mail/?view=cm&fs=1&to=info@themailwhale.in"
            target="_blank"
            rel="noopener noreferrer"
            className="flex items-center mt-2"
          >
            <img src={emailIcon} alt="Email" className="w-[27px] h-[27px]" />
            <p className="ml-4 text-[30px]" style={{ fontFamily: 'Dongle, sans-serif', color: '#000' }}>
              info@themailwhale.in
            </p>
          </a>

          <div className="flex gap-4 mt-4">
            <a href="https://www.instagram.com/tmw.themailwhale/" target="_blank" rel="noopener noreferrer">
              <img src={instagramIcon} alt="Instagram" className="w-[40px] h-[40px]" />
            </a>
            <a href="https://www.linkedin.com/company/the-mail-whale/" target="_blank" rel="noopener noreferrer">
              <img src={linkedinIcon} alt="LinkedIn" className="w-[40px] h-[40px]" />
            </a>
            <a href="https://www.youtube.com/@TMW_TheMailWhale" target="_blank" rel="noopener noreferrer">
              <img src={youtubeIcon} alt="YouTube" className="w-[40px] h-[40px]" />
            </a>
            <a href="https://x.com/TheMailWhale_" target="_blank" rel="noopener noreferrer">
              <img src={XIcon} alt="X" className="w-[40px] h-[40px]" />
            </a>
          </div>
        </div>
      </div>

      <div className="w-full border-t border-gray-300 my-6" />

      <p className="text-center" style={{ fontFamily: 'Dongle, sans-serif', fontWeight: 400, fontSize: '30px', lineHeight: '150%', color: '#283646' }}>
        Copyright The Mail Whale 2025 | All rights reserved.
      </p>
    </footer>
  );
}

export default Footer;